import type { SummaryDisplayData } from '~/features/my-wallet/types/summary'
import { buildSummaryView } from '~/features/my-wallet/utils/summary'
import { useMyWalletScreenState } from './useMyWalletScreenState'

// The summary has no endpoint of its own: it reads the receiving-model query.
export function useSummary() {
  const { paymentModel, ...screen } = useMyWalletScreenState()

  const displayData = computed<SummaryDisplayData | null>(() =>
    paymentModel.value ? buildSummaryView(paymentModel.value) : null,
  )

  return {
    ...screen,
    displayData,
  }
}
